<template>
  <div class="module-wrapper">
    <div v-if="data.type === 1" class="name">
      <span v-show="moduleMode" class="text">{{ data.name }}</span>
    </div>
    <template v-for="(item, index) in data.contents">
      <camp-learn-plan-module-item :camp-opened="campBegun" :series-id="seriesId" :data="item" :is_paid="isPaid" :module-type="data.type" :key="index"></camp-learn-plan-module-item>
    </template>
  </div>
</template>

<script>
import campLearnPlanModuleItem from '@/components/campLearnPlanModuleItem/campLearnPlanModuleItem.vue';

export default {
  components: {
    campLearnPlanModuleItem,
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    isPaid: {
      type: Boolean,
      default: false
    },
    seriesId: {
      type: Number,
      default: 0
    },
    trainingDate: {
      type: String,
      default: ''
    },
    moduleMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    campBegun() {
      const trainingDate = new Date(Date.parse(this.trainingDate.replace(/-/g, '/')));
      const curDate = new Date();
      if (trainingDate < curDate) {
        return true;
      }
      return false;
    }
  },
};
</script>

<style lang="stylus" scoped>
@import './../../common/stylus/variable.styl';
@import './../../common/stylus/mixin.styl';
.module-wrapper {
  .name {
    width: 100%;
    padding-top 16px
    text-align left
    .text {
      display inline-block
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      // line-height: 14px;
      padding-top 8px
      padding-bottom 12px
    }
  }
}
</style>
